import React, { useState, useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as Franchise } from "../../Global Icons/Franchise.svg";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import TextInput from "../../Global Functions/textInput";
import TwoButtons from "../../Global Functions/buttons";
import {
  updateCancellationPolicy,
  viewCancellationPolicy,
} from "../../Redux/Actions/cancellationPoliciesAction";
import { useNavigate, useParams } from "react-router-dom";

const UpdateCancellationPolicy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [formState, setFormState] = useState({
    title: "",
    policy: [""],
    type: "dooritt",
    id: "",
  });

  // Select policy details from Redux state
  const policyDetails = useSelector(
    (state) => state.cancellationPolicies.policy
  );

  useEffect(() => {
    if (id) {
      dispatch(viewCancellationPolicy(id));
    }
  }, [dispatch, id]);

  // When policyDetails updates, populate the form
  useEffect(() => {
    if (policyDetails) {
      setFormState({
        title: policyDetails.title || "",
        policy: Array.isArray(policyDetails.policy)
          ? policyDetails.policy
          : [""],
        type: policyDetails.type || "dooritt",
        id: policyDetails._id || id,
      });
    }
  }, [policyDetails, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleArrayChange = (field, index, value) => {
    const updatedArray = [...formState[field]];
    updatedArray[index] = value;
    setFormState((prev) => ({
      ...prev,
      [field]: updatedArray,
    }));
  };

  const handleAddArrayItem = (field) => {
    setFormState((prev) => ({
      ...prev,
      [field]: [...prev[field], ""],
    }));
  };

  const handleRemoveArrayItem = (field, index) => {
    const updatedArray = [...formState[field]];
    if (updatedArray.length > 1) {
      updatedArray.splice(index, 1);
      setFormState((prev) => ({
        ...prev,
        [field]: updatedArray,
      }));
    } else {
      toast.error("At least one item is required.");
    }
  };

  const handleUpdate = async () => {
    if (!formState.title.trim()) {
      return toast.error("Title is required");
    }
    if (
      !formState.policy ||
      formState.policy.length === 0 ||
      formState.policy.some((p) => p.trim() === "")
    ) {
      return toast.error("Please fill all policy items");
    }
    for (let i = 0; i < formState.policy.length; i++) {
      if (!formState.policy[i].trim()) {
        return toast.error(`Policy item ${i + 1} cannot be empty`);
      }
    }
    if (!["builder", "dooritt"].includes(formState.type)) {
      return toast.error("Invalid type selected");
    }

    const payload = {
      id: formState.id,
      title: formState.title.trim(),
      policy: formState.policy.map((p) => p.trim()),
      type: formState.type,
    };

    try {
      const response = await dispatch(updateCancellationPolicy(payload));
      if (response) {
        if (response.statusCode === 200 || response.status === "success") {
          toast.success("Cancellation Policy updated successfully!");
          navigate("/cancellation_policies");
        } else if (response.message) {
          toast.error(response.message);
        } else {
          toast.error("No response from server");
        }
      } else {
        toast.error("No response from server");
      }
    } catch (error) {
      toast.error("Error updating cancellation policy");
    }
  };

  return (
    <MainLayout>
      <div className="franchise-form-container">
        <div className="franchise-form-wrapper franchise-card">
          <div className="franchise-card-content">
            <div className="franchise-header">
              <div className="franchise-header-icon">
                <Franchise />
              </div>
              <h1>Update Cancellation Policy</h1>
            </div>

            <div className="form-section">
              <TextInput
                label="Title"
                name="title"
                value={formState.title}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            {/* Type Select */}
            <div className="form-section">
              <label className="form-label" htmlFor="type_select">
                Type <span style={{ color: "red" }}>*</span>
              </label>
              <select
                id="type_select"
                name="type"
                value={formState.type}
                onChange={handleChange}
                className="form-input"
              >
                <option value="builder">Builder</option>
                <option value="dooritt">dooritt</option>
              </select>
            </div>

            {/* Policy array input */}
            <div className="form-section">
              <label className="form-label">
                Policy <span style={{ color: "red" }}>*</span>
              </label>
              {formState.policy.map((term, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <TextInput
                    value={term}
                    onChange={(e) =>
                      handleArrayChange("policy", index, e.target.value)
                    }
                    inputClass="form-input"
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveArrayItem("policy", index)}
                    style={{
                      marginLeft: 8,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#d9534f",
                    }}
                    aria-label="Remove policy item"
                  >
                    <span role="img" aria-label="delete">
                      🗑️
                    </span>
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => handleAddArrayItem("policy")}
              >
                Add Policy Item
              </button>
            </div>

            <div className="form-navigation">
              <button
                type="button"
                onClick={() => navigate("/cancellation_policies")}
              >
                Cancel
              </button>
              <TwoButtons onClick2={handleUpdate} buttonHead2="Update" />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default UpdateCancellationPolicy;
